module.exports = __webpack_public_path__ + "static/10400556_21576147223_4132_n-9d7196f4f18756327cf34d77a0086dc0.jpg";